import { environmentConfig } from "@src/appV2/environment";

import { COGNITO_IDS } from "./cognitoIds";

interface CognitoConfig {
  userPoolId: string;
  clientId: string;
  oauthDomain: string;
}

function getCognitoConfig(): CognitoConfig {
  const environmentName = environmentConfig.REACT_APP_ENVIRONMENT_NAME;
  const ids = COGNITO_IDS[environmentName] ?? COGNITO_IDS.development;

  return {
    ...ids,
    oauthDomain: environmentConfig.REACT_APP_COGNITO_OAUTH_DOMAIN,
  };
}

export const cognitoConfig = getCognitoConfig();
